

<script>
import MenuApi from "@/services/menu-api";
import { Splide, SplideSlide } from '@splidejs/vue-splide';
import LocationPermissionModal from "@/components/LocationPermissionModal.vue";
import { mapGetters } from 'vuex';
import CartBottomSheet from "@/components/CartBottomSheet.vue"
import CartSummary from "@/components/CartSummary.vue"
import EnableQuote from "@/components/EnableQuote.vue"
import QuantityControl from "@/components/QuantityControl.vue"
import MenuItemCard from "@/components/MenuItemCard.vue"
import MenuItemRow from "@/components/MenuItemRow.vue"
import MenuGroups from "@/components/MenuGroups.vue"
// import ProcessingOrdersApi from "@/services/processing-orders-api";
import TruncatedText from "@/components/TruncatedText.vue"
import ExternalBrowserBanner from "@/components/ExternalBrowserBanner.vue";
import FloatingButton from "@/components/FloatingButton.vue";

export default {
  components: {
    Splide,
    SplideSlide,
    LocationPermissionModal,
    CartBottomSheet,
    CartSummary,
    EnableQuote,
    QuantityControl,
    MenuItemCard,
    MenuItemRow,
    TruncatedText,
    MenuGroups,
    ExternalBrowserBanner,
    FloatingButton
  },

  props: {
    tid: {
      type: Number,
      default: null
    },
    ts: {
      type: String,
      default: ''
    },
  },

  watch :{

    '$route': {
        immediate: true,
        deep: false, 
        handler(route) {
        this.codeMenu = route.params.code;
        this.getMenuByCodeForAnonymous()
        },
    },

    currentLang:function(){
      this.getMenuByCodeForAnonymous()
    },

    showWishlistDescriptionModal:function(val) {
        if (val) {
          history.pushState(null, null, location.href);
          window.onpopstate = () => {
            this.showWishlistDescriptionModal = false;
          };
        } else {
          window.onpopstate = null;
        }
    },
      
    coords(newVal, prevVal) {
      if(prevVal == null && newVal != null){
        this.fetchCart();
      }
    },

  },

  beforeDestroy() {
    this.$store.dispatch('location/stopPeriodicLocationFetch');
    window.onpopstate = null;
  },


  created() {
      this.loadWishlist();
      this.fetchCart();
      this.getMenuGroups();
      this.checkSignatureForVirtualTables();
  },

  computed: {
    hasMultipleImages() {
      return this.modalDescription &&
            this.modalDescription.imagesCode &&
            this.modalDescription.imagesCode.length > 1;
    },

    ...mapGetters('location', ['coords', 'coordsError', 'gpsLocalizationValid', 'locationLoading']),
    ...mapGetters('cart', ['cart', 'isLoadingCart']),

    showWarringTopBar() {
      return this.coordsError;
    },

    isTable() {
        const url = new URL(window.location.href);
        const tid = url.searchParams.get('tid');
        const ts = url.searchParams.get('ts');
        const pathSegments = url.pathname.split('/');
        const menuCode = pathSegments[pathSegments.length - 1];
        return menuCode != null && tid != null && ts != null;
      },

    orderIsActif() {
        if (!this.isTable) {
          return false
        }

        if (this.menu.orderMenuWithOrder && this.menu.orderMenuIsRequiredGps) {
          return (
            !this.coordsError &&
            this.gpsLocalizationValid &&
            this.gpsLocalizationValid.localizationIsValid
          );
        }

        return this.menu.orderMenuWithOrder;
      },

      quoteIsActif() {
        if (!this.isTable) {
          return false;
        }
        const params = new URLSearchParams(window.location.search);
        const md = this.mode ? this.mode : params.get("md");
        return this.menu.orderMenuWithQuote && md === "quote";
      },

      showCartSummary() {
        const draftItems = this.cart?.lines?.draft?.items || [];
        const submittedItems = this.cart?.lines?.submitted?.items || [];
        return draftItems.length > 0 || submittedItems.length > 0;
      },

  },

  methods:{
    actifQuote() {
      const params = new URLSearchParams(window.location.search);
      this.mode = params.get("md");
    },

    onHdImageLoad(img) {
      this.$set(this.currentImageLoaded, img, true);
      this.$nextTick(() => {
        this.$refs.splideRef.splide.refresh();
      });
    },

    checkSignatureForVirtualTables(){
      if(this.ts != null && this.tid != null && this.tid > 100000){
        MenuApi.checkSignatureForVirtualTables()
      }
    },

    handelSelectedGroup(group){
      this.groupSelected = group
      this.getMenuByCodeForAnonymous()
    },

  //   noteFieldIsVisible(item){
  //     return item.id == this.showNoteByItemId
  //  },

    showNoteField(item) {
      this.showNoteByItemId = this.showNoteByItemId == null ? item.id : null ;
    },

    refreshLocation(){
      this.getLocation()
    },

    onVideoReady() {
      this.videoReady = true
    },

    // findCallWaiterReason(){
    //   ProcessingOrdersApi.findCallWaiterReason(this.currentLang).then((result) =>{
    //     if(result){
    //       this.callWaiterReasons = result
    //     }
    //   } )
    // },

    closeSheet(){
      this.showSheet = false
    },

    handleQuantityChange(qte){
      this.quantity= qte
    },

    expandSheet() {
      this.showSheet = true
      this.$refs.cartComp.open();
      this.fetchCart();
    },

    close() {
      this.$refs.myBottomSheet.close();
    },

    fetchCart(){
      this.$store.dispatch('cart/fetchCart')
    },

    addToOrder(){
      this.$store.dispatch('cart/addToOrder', [{ menuItemId: this.modalDescription.id, quantity: this.quantity, note: this.lineNote }])
      this.showWishlistDescriptionModal = false
    },

    startPeriodicLocationFetch(){
        if(this.tid && this.ts){
          this.$store.dispatch('location/startPeriodicLocationFetch')
        }
    },

    // callWaiter(callWaiterReason){
    //   this.waiterCalled= true
    //   ProcessingOrdersApi.callWaiter(callWaiterReason).then(() =>{
    //       setTimeout(() => {
    //           this.waiterCalled = false;
    //       }, 2000);
    //   })
    // },    

    getLocation(){
        if(this.tid && this.ts){
          this.$store.dispatch('location/fetchLocationWithGpsStatus')
        }
    },

    goPrev() {
      this.$refs.splideRef.splide.go('<');
    },
    goNext() {
      this.$refs.splideRef.splide.go('>');
    },


    getMenuGroups(){
      MenuApi.getMenuGroups(this.codeMenu).then((result) => {
        this.menuGroups = result
      } )
    },

    trackingEventMenu(type, itemId, sectionId, subSectionId){
      const ssid = this.$cookies.get('SSID');
    
      const trackingBody = {
                          type: type,
                          ssid:ssid, 
                          itemId:itemId, 
                          sectionId:sectionId, 
                          subSectionId:subSectionId, 
                              }
      
      MenuApi.trackingEventMenu(trackingBody)
    },

     setLanguage(lang) {
      this.currentLang = lang;
    },

    loadWishlist() {
      const stored = this.$cookies.get(this.codeMenu);
      this.wishlist = Array.isArray(stored) ? stored : [];
    },

    setItemListCookie(cookieName, itemList) {
        
        const maxAge = 307584000;

        const domain = window.location.hostname.startsWith("www.")
            ? window.location.hostname.substring(4)
            : window.location.hostname;
        document.cookie = cookieName + "=" + JSON.stringify(itemList) + "; Max-Age=" + maxAge + " ; path=/; domain=" + domain + ";";
    },

    
    addToWithList(itemId, refreshItemsWishList,sectionId) {
        const key = this.codeMenu;
        const rawCookie = document.cookie
            .split('; ')
            .find(row => row.startsWith(`${key}=`));
        
        if (rawCookie) {
            try {
                this.wishlist = JSON.parse(decodeURIComponent(rawCookie.split('=')[1]));
            } catch (e) {
                this.wishlist = [];
            }
        }

        if (!this.wishlist.includes(itemId)) {
            this.wishlist.push(itemId);
            this.setItemListCookie(key, this.wishlist);
        }

        if(refreshItemsWishList){
            this.getItemsWishlist()
        }

        this.trackingEventMenu(2,itemId,sectionId)
    },


    removeFromWishlist(itemId, refreshItemsWishList) {
        const key = this.codeMenu;
    
        const rawCookie = document.cookie
            .split('; ')
            .find(row => row.startsWith(`${key}=`));

        if (rawCookie) {
            try {
                this.wishlist = JSON.parse(decodeURIComponent(rawCookie.split('=')[1]));
            } catch (e) {
                this.wishlist = [];
            }
        }

        this.wishlist = this.wishlist.filter(id => id !== itemId);
        this.setItemListCookie(key, this.wishlist);

        if(refreshItemsWishList){
            this.getItemsWishlist()
        }
    },

    getItemsWishlist() {
        if(this.wishlist == null || this.wishlist.length == 0){
            this.wishlistItems = [];
        }
      MenuApi.getItemsWishlist(this.wishlist, this.codeMenu, this.currentLang  ).then((result) => {
        if (result) {
          this.wishlistItems = result;
        }
      });
    },


    isInWishlist(itemId) {
      return this.wishlist.includes(itemId);
    },

    scrollToTop() {
        window.scrollTo({top: 0,behavior: 'smooth'});
    },


    getMenuByCodeForAnonymous() {
      MenuApi.getMenuByCodeForAnonymous(this.codeMenu, this.currentLang, this.groupSelected == null || this.groupSelected.id === -1  ? null : this.groupSelected.id, this.tid ).then((result) => {
        if (result) {
          this.menu = result;
          document.documentElement.style.backgroundColor = this.menu.backgroundColor;
          if(this.currentLang == null){
             const supportedCodes = result.supportedLanguages;
          
             if (Array.isArray(supportedCodes)) {
              this.supportedLanguages = this.languages
                .filter(lang => supportedCodes.includes(lang.code))
                .sort((a, b) => supportedCodes.indexOf(a.code) - supportedCodes.indexOf(b.code));

            this.currentLang = this.supportedLanguages[0].code;
            } else {
              this.supportedLanguages = [];
              this.defaultLanguage = null;
            }

            if(this.menu.orderMenuWithOrder && this.menu.orderMenuIsRequiredGps){
              this.startPeriodicLocationFetch()
            }
            
          }
        }
      });
    },
    
    onShow(index) {
      this.$set(this.openSections, index, true);
    },
    onHide(index) {
      this.$set(this.openSections, index, false);
    },

    onShowSubSection(sectionIndex, subSectionIndex) {
      const key = `${sectionIndex}-${subSectionIndex}`;
      this.$set(this.openSubSections, key, true);
    },

    onHideSubSection(sectionIndex, subSectionIndex) {
      const key = `${sectionIndex}-${subSectionIndex}`;
      this.$set(this.openSubSections, key, false);
    },


    toggleModalDescription(item, sectionId) {
        this.currentImageLoaded={}
        this.showNoteByItemId = null
        this.lineNote = null
        this.quantity = 1
        this.modalDescription = item;
        this.showWishlistDescriptionModal = true
        this.trackingEventMenu(1 , item.id, sectionId )

    },

    openWishListModal(){
        this.getItemsWishlist()
        this.showWishlistModal = true
    },
    normalizedUrl(url) {
    if (!/^https?:\/\//i.test(url)) {
      return 'https://' + url;
    }
    return url;
    },

    handleDebugTap() {
      const now = Date.now();

      const TAP_TIMEOUT = 500;
      const REQUIRED_TAPS = 15;

      if (now - this.lastTapTime > TAP_TIMEOUT) {
        this.debugTapCount = 0;
      }

      this.debugTapCount++;
      this.lastTapTime = now;

      if (this.debugTapCount >= REQUIRED_TAPS) {
        this.debugVisible = true;
        this.debugTapCount = 0;
        console.log('Debug panel unlocked');
      }
    },

    scrollToMenu() {
      this.$refs['menu-title'].scrollIntoView({ behavior: 'smooth' });
    }
    
  },
  data() {
    return {
    showWishlistDescriptionModal:false,
    modalDescription:null,
    showWishlistModal:false,
    wishlist : [],
    wishlistItems:[],
    inWishlistKey:1,
    codeMenu:null,
    menu:null,
    detailsReady: false,
    banner:{ caption: 'Visit Our Restaurant & Enjoy 20% Off!'},
    openSections: {},
    openSubSections: {},
    currentLang:null,
    languages: [ { code: 'fr', label: 'Français' },{ code: 'en', label: 'Anglais' }, { code: 'ar', label: 'العربية' }],
    supportedLanguages:null,
    showModal: false,

    bgColor: '#000000',
    position: 'botom-right',
    quantity:1,
    showSheet:false,
    // waiterCalled:false,
    // callWaiterReasons: [],
    videoReady:false,

    debugTapCount: 0,
    lastTapTime: 0,
    debugVisible: false,
    showNoteByItemId: null,
    lineNote: null,
    menuGroups:[],
    currentImageLoaded: {},
    mode: null,
    }

  },
};
</script>


<template>
  <div class="menu-screen" v-if="this.menu"  :style="{
    backgroundColor: menu.backgroundColor || 'inherit'
  }">



  <header>
    <b-navbar fixed="top" style="display: block;" class="p-0">

      <div class="shadow-sm p-1 m-0 " style="background-color: #000;">
          <b-container class="d-flex" @click="handleDebugTap">

          <div>
            <img src="@/assets/icons/home-w.svg"  height="22" alt="home" @click="scrollToTop()" style="cursor: pointer;"/>
            <a v-if="menu.instagramUrl" :href="normalizedUrl(menu.instagramUrl)" target="_blank" rel="noopener">
              <img src="@/assets/icons/instagram-w.svg" height="22" class="ml-2" alt="Instagram" style="cursor: pointer;" />
            </a>

            <a  v-if="menu.googleReviewUrl" :href="normalizedUrl(menu.googleReviewUrl)" target="_blank" rel="noopener">
              <img src="@/assets/icons/starRate.svg" height="22" class="ml-2" alt="Google Reviews" style="cursor: pointer;" />
            </a>
          </div>


          <div class="position-relative">

            <!-- <b-dropdown  v-if="orderIsActif && menu && menu.orderMenuCallWaiterIsActive && !waiterCalled && (this.tid != null && this.tid < 100000 ) && !this.quoteIsActif"
              variant="link"
              right
              toggle-class="p-0"
              no-caret
              class="mr-2"
            > 
              <template #button-content>
                <img src="@/assets/icons/waiter-j.svg" height="25" alt="waiter" @click="findCallWaiterReason();"/>
              </template>
            
              <b-dropdown-header>
                <div class="text-center text-muted font-size-12 font-weight-bold">
                  <span class="text-uppercase">Appeler le serveur pour</span>
                </div>
              </b-dropdown-header>
            
              <b-dropdown-item
                v-for="reason in callWaiterReasons"
                :key="reason.code"
                @click="callWaiter(reason.code)"
                :class="currentLang == 'ar' ? 'text-right' : ''"
                style="z-index: 99999999;"
              >
                <img v-if="reason.code == 1" src="@/assets/icons/bill.svg" height="20" class="mr-2" alt="Google Reviews" style="cursor: pointer;" />
                <img v-else-if="reason.code == 0" src="@/assets/icons/clean-table.svg" height="20" class="mr-2" alt="Google Reviews" style="cursor: pointer;" />
                <img v-else-if="reason.code == 2" src="@/assets/icons/help.svg" height="20" class="mr-2" alt="Google Reviews" style="cursor: pointer;" />

                <span class="font-size-14" >{{ reason.value }}</span>
              </b-dropdown-item>

            </b-dropdown> -->

            <!-- <img v-else-if="orderIsActif && waiterCalled" src="@/assets/icons/bell-alt-ring.svg" height="20" alt="bellRing" class="bell-effect-diagonal mr-2"/> -->
            
            <b-dropdown  v-if="supportedLanguages && supportedLanguages.length > 1  "
              variant="link"
              right
              toggle-class="p-0"
              no-caret
              class="mr-2"
            > 
              <template #button-content>
                <img :src="require(`@/assets/icons/${currentLang}.svg`)" alt="language" height="20" />
              </template>
              <b-dropdown-item
                v-for="lang in supportedLanguages"
                :key="lang.code"
                @click="setLanguage(lang.code)"
              >
              <img :src="require(`@/assets/icons/${lang.code}.svg`)" :alt="lang.label" height="20" class="mr-2" />
                {{ lang.label }}
              </b-dropdown-item>

            </b-dropdown>

            <b-button variant="link" class="text-danger p-0 " :class="this.wishlist.length ? 'pr-3' : ''" @click="openWishListModal()">
                <img src="@/assets/icons/heart-full-red.svg"  height="25" alt="heart"/>
              <b-badge
                v-if="this.wishlist.length > 0"
                variant="danger"
                class="position-absolute translate-middle rounded-circle mt-0 font-weight-bold"
                style="font-size:10px;"
              >
                {{ this.wishlist.length }}
              </b-badge>
            </b-button>

          </div>
        </b-container>
      </div>

      <div v-if="menuGroups && menuGroups.length > 0">
        <MenuGroups @group-selected="handelSelectedGroup" :menuGroups="menuGroups" 
        :groupTitleColor="menu.groupTitleColor"
        :groupFontColor="menu.groupFontColor"
        :groupFontFamily="menu.groupFontFamily"
        :groupFontSize="menu.groupFontSize"
        :groupFontWeight="menu.groupFontWeight"
        :groupFontStyle="menu.groupFontStyle"
        
        />
      </div>
    </b-navbar>
    

   <b-navbar v-if="this.debugVisible && this.tid && this.ts && (this.coords || (this.coordsError) )"
      fixed="top"
      :class="[
        'second-navbar shadow-sm m-0 px-3 py-2',
        coords && !coordsError  ? 'bg-success' :  'bg-warning'
      ]"
      style="z-index: 9;"
    >
      <b-container class=" text-center">
        
        <div v-if="coords && !coordsError " class="d-flex align-items-center">

          <div v-if="locationLoading" class="d-flex align-items-center text-white">
            <b-spinner small type="border" variant="light" class="mr-2" />
          </div>

          <div v-if="coords">
            <small class="text-white text-left">
              <strong>Lat:</strong> {{ coords.latitude.toFixed(6) }},
              <strong>Lng:</strong> {{ coords.longitude.toFixed(6) }},
              <div><strong>Accuracy:</strong> ±{{ coords.accuracy.toFixed(2) }}m</div>
            </small>
          </div>
        </div>

        <div v-if="coords && !coordsError " >
          <span class="fw-semibold text-white">
            {{ this.gpsLocalizationValid && this.gpsLocalizationValid.localizationIsValid ? 'Cmde Activée' : 'Cmde Désactivée' }}
            <i  v-if="!locationLoading" class="fas fa-sync-alt ml-2" style="cursor: pointer;" @click="getLocation()"></i>
          </span>
        </div>

        <div v-else-if="coordsError" class="col-12 text-center">
          <span class="font-weight-semibold text-white d-inline-flex align-items-center text-center" style="cursor: pointer;">
            {{ this.coordsError ? 'Une erreur est survenue. Veuillez réessayer.' : 'Veuillez activer la localisation sur votre appareil pour utiliser cette fonctionnalité.' }}
            <i v-if="!locationLoading" class="fas fa-sync-alt ml-2" title="Réessayer" style="cursor: pointer;" @click="getLocation()" ></i>
          </span>
        </div>



      </b-container>
    </b-navbar>

    <div v-if="menu" :class="menuGroups && menuGroups.length > 0 ? 'banner-offset-with-groups' : 'banner-offset-no-groups'" class="d-flex flex-column align-items-center justify-content-center">
      <div class="w-100">
        

        <div   v-if="menu && menu.image" >

          <div v-if="menu.bannerMediaType == 1" class="position-relative w-100">
            <img  v-show="!videoReady && menu && menu.thumbnailImage" :src="'/api/image/get/menu/' + menu.thumbnailImage" alt="Banner" class="img-fluid w-100"/>

            <div style="position: relative; width: 100%; height: 100%;">
              <video v-show="videoReady" width="100%" height="100%" class="banner-video-mobile" loop playsinline autoplay muted @canplaythrough="onVideoReady" >
                  <source  :src="'/api/image/get/menu/' + menu.image" type="video/mp4" >
              </video>

              <div class="scroll-down-btn" @click="scrollToMenu">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <polyline points="6 9 12 15 18 9" />
                </svg>
              </div>
            </div>


            
          </div>
          <img  v-else :src="'/api/image/get/menu/small/' + menu.image" alt="Banner" class="img-fluid w-100"/>

        </div>

          <div class="banner-zone" :style="{
            fontFamily: menu.titleFontFamily || 'inherit',
            color: menu.titleFontColor || 'inherit',
            fontSize: menu.titleFontSize || 'inherit',
            textDecoration: menu.titleTextDecoration || 'inherit',
            fontStyle: menu.titleFontStyle || 'inherit',
            fontWeight: menu.titleFontWeight || 'inherit'
          }">
          <div id="menu-title" ref="menu-title"  class="banner-title">{{ menu.title }}</div>
        </div>
      </div>
    </div>
  </header>

    <main class=" mt-5 mb-5 " :class="orderIsActif || menu.orderMenuWithQuote ? 'pb-5' : ''">

        <ExternalBrowserBanner />

        <div v-if="this.menu && this.menu.menuSections">


            <section  v-for="(section, secIndex) in menu.menuSections"  :key="secIndex" class="mb-12 pr-2 pl-2"  >

            <div   v-b-toggle="'accordion-' + secIndex" class="d-flex justify-between align-items-center mb-3 mt-3 cursor-pointer pb-3" style="border-bottom: 1px solid #ddd;">
                <div class="flex-grow-1 text-center" 
                @click="!openSections[secIndex] && trackingEventMenu(0, null, section.id)"
                :style="{
                    fontFamily: menu.sectionFontFamily || 'inherit',
                    color: menu.sectionFontColor || 'inherit',
                    fontSize: menu.sectionFontSize || 'inherit',
                    textDecoration: menu.sectionTextDecoration || 'inherit',
                    fontStyle: menu.sectionFontStyle || 'inherit',
                    fontWeight: menu.sectionFontWeight || 'inherit'
                  }">  {{ section.name }}</div>
               
                <img src="@/assets/icons/angle-down.svg" height="25" class="ml-2" :class="{ 'rotate-180': openSections[secIndex] }"
                    style="transition: transform 0.3s ease;"  />
   

            </div>

            <b-collapse v-if="section.menuItem && section.menuItem.length"  :id="'accordion-' + secIndex" role="tabpanel"  @show="onShow(secIndex)"     @hide="onHide(secIndex)">

                <div v-if="section.withImage" class="itm-table text-left"  dir="rtl" >
                     <MenuItemCard
                        v-for="(item, index) in section.menuItem"
                        :key="index"
                        :item="item"
                        :section-id="section.id"
                        :with-image="section.withImage"
                        :order-is-actif="orderIsActif || quoteIsActif"
                        :current-lang="currentLang"
                        :menu="menu"
                        :is-in-wishlist="isInWishlist"
                        @toggleModal="toggleModalDescription"
                        @addToWishlist="addToWithList($event, false, section.id)"
                        @removeFromWishlist="removeFromWishlist"
                      />
                </div>

                <div v-else class="item-list">

                  <MenuItemRow
                    v-for="(item, index) in section.menuItem"
                    :key="index"
                    :item="item"
                    :index="index"
                    :sec-index="secIndex"
                    :section-id="section.id"
                    :menu="menu"
                    :order-is-actif="orderIsActif || quoteIsActif"
                    :is-in-wishlist="isInWishlist"
                    @toggleModalDescription="toggleModalDescription"
                    @addToWishlist="addToWithList"
                    @removeFromWishlist="removeFromWishlist"
                  />


                </div>
                
            </b-collapse>

              <b-collapse
                v-else-if="section.menuSubSection && section.menuSubSection.length"
                :id="'accordion-' + secIndex"
                role="tabpanel"
              >
                <section
                  v-for="(subSection, subIndex) in section.menuSubSection"
                  :key="subIndex"
                  class="mb-12 "
                >
                  <div
                    v-b-toggle="'sub-accordion-' + secIndex + '-' + subIndex"
                    class="d-flex justify-content-between align-items-center mb-3 mt-3 cursor-pointer pb-3 mr-3 ml-3"
                    style="border-bottom: 1px solid #ddd;"
                  >
                    <div
                      class="flex-grow-1 text-center"
                      @click="!openSubSections[`${secIndex}-${subIndex}`]  && trackingEventMenu(0, null, section.id, subSection.id)"
                      :style="{
                        fontFamily: menu.subSectionFontFamily || 'inherit',
                        color: menu.subSectionFontColor || 'inherit',
                        fontSize: menu.subSectionFontSize || 'inherit',
                        textDecoration: menu.subSectionTextDecoration || 'inherit',
                        fontStyle: menu.subSectionFontStyle || 'inherit',
                        fontWeight: menu.subSectionFontWeight || 'inherit'
                      }"
                    >
                      {{ subSection.name }}
                    </div>

                    <img
                      src="@/assets/icons/angle-down.svg"
                      height="25"
                      :class="{ 'rotate-180': openSubSections[`${secIndex}-${subIndex}`]  }"
                      style="transition: transform 0.3s ease;"
                    />
                  </div>

                  <b-collapse
                    v-if="subSection && subSection.menuItem && subSection.menuItem.length"
                    :id="'sub-accordion-' + secIndex + '-' + subIndex"
                    role="tabpanel"
                    @show="onShowSubSection(secIndex, subIndex)"
                    @hide="onHideSubSection(secIndex, subIndex)"
                  >
                    <div v-if="subSection.withImage" class="itm-table text-left" dir="rtl">
                      <MenuItemCard
                        v-for="(item, index) in subSection.menuItem"
                        :key="index"
                        :item="item"
                        :section-id="subSection.id"
                        :with-image="subSection.withImage"
                        :order-is-actif="orderIsActif || quoteIsActif"
                        :current-lang="currentLang"
                        :menu="menu"
                        :is-in-wishlist="isInWishlist"
                        @toggleModal="toggleModalDescription"
                        @addToWishlist="addToWithList($event, false, subSection.id)"
                        @removeFromWishlist="removeFromWishlist"
                      />
                    </div>

                    <div v-else class="item-list">
                      <MenuItemRow
                        v-for="(item, index) in subSection.menuItem"
                        :key="index"
                        :item="item"
                        :index="index"
                        :sec-index="secIndex"
                        :section-id="subSection.id"
                        :menu="menu"
                        :order-is-actif="orderIsActif || quoteIsActif"
                        :is-in-wishlist="isInWishlist"
                        @toggleModalDescription="toggleModalDescription"
                        @addToWishlist="addToWithList"
                        @removeFromWishlist="removeFromWishlist"
                      />

                    </div>
                  </b-collapse>
                </section>
              </b-collapse>

            </section>
        </div>

    </main>


    <b-modal
        v-model="showWishlistModal"
        title="Favoris"
        hide-footer
        hide-header
        centered
        size="xl">

        <div class="p-2">

      <div class="float-left">
          <img src="@/assets/icons/close-dark.svg" height="25" @click="showWishlistModal = false"  />
      </div>

      <div class="text-center text-dark font-size-24 mb-4 font-weight-bold"
          :style="{ 
            fontFamily: menu.productFontFamily || 'inherit',
          }"
      >
        Favoris
      </div>

      <div v-if="wishlistItems && wishlistItems.length > 0">
        <div
          v-for="item in wishlistItems.filter(i => i && i.id)"
          :key="item.id"
          class="wishlist-item card mb-3"
        >

        <div class="wishlist-item d-flex align-items-center p-2" @click="toggleModalDescription(item, null)">
          <div v-if="item.image" class="image-container mr-3">
         
            <div class="image-wrapper">
                <img
                    :src="'/api/image/get/menu/small/' + item.image"
                    alt="Item Image"
                    class="wishlist-img"
                  />
            </div>
           
          </div>

          <div class="item-wishlist-line flex-grow-1">
            <div class="mb-1 text-dark font-weight-bold font-size-14 line-clamp-2"
              :style="{ 
                fontFamily: menu.productFontFamily || 'inherit',
                color: menu.productFontColor || 'inherit',
                fontSize: menu.productFontSize || 'inherit',
                textDecoration: menu.productTextDecoration || 'inherit',
                fontStyle: menu.productFontStyle || 'inherit',
                fontWeight: menu.productFontWeight || 'inherit'
              }"
            >{{ item.name }}
          
          </div>
            <div 
              class="mb-1 text-dark d-flex justify-content-between align-items-center"
              :style="{
                fontFamily: menu.productFontFamily || 'inherit',
                fontWeight: menu.productFontWeight || 'inherit'
              }"
            >
              <span>{{ item.price }}</span>


            </div>
          </div>

          <div v-if="(orderIsActif || quoteIsActif)  && !item.isNotAvailableOnline " class="add-to-cart-icon-wishlist d-flex justify-content-center align-items-center ml-auto" @click="toggleModalDescription(item, null)" >
            <img src="@/assets/icons/add-p.svg" height="15" width="15" />
          </div>
          <div class="heart-icon ml-auto">
            <img v-if="isInWishlist(item.id)" src="@/assets/icons/heart-full-red.svg" height="20" alt="heart" @click.stop="removeFromWishlist(item.id, true)" />
            <img v-else src="@/assets/icons/heart-red.svg" height="20" alt="heart" @click.stop="addToWithList(item.id, true, null)" />
          </div>


        </div>
        </div>
      </div>

      <div v-else class="text-center text-dark d-flex justify-content-center align-items-center font-size-14" style="min-height: 10em;">
        Aucun favori pour le moment. Ajoutez-en en cliquant sur le cœur !
      </div>

        </div>
    </b-modal>

    <b-modal
      v-model="showWishlistDescriptionModal"
      v-if="modalDescription"
      hide-footer
      hide-header
      centered
      size="md"
      class=""
    >



      <div class="m-0 p-0 text-center position-relative">

    <div class="modal-description-header" style="z-index: 10;">

        <div><img src="@/assets/icons/close.svg" height="30" @click="showWishlistDescriptionModal = false"  /></div>
    </div>

     <Splide
        ref="splideRef"
        :options="{
          
          type: 'loop',
          drag: hasMultipleImages,
          arrows: false,
          pagination: hasMultipleImages,
          rewind: false,
          autoWidth:true,
        }"

      >
        <SplideSlide
          v-for="(img, index) in modalDescription.imagesCode"
          :key="index"
        >
          <div class="item-modal-img mx-auto" style="width: min(500px, 100vw);">
            <div style="padding-bottom: 100%; position: relative;padding-bottom:124%">


             
             <img
                v-if="img && img.trim().length > 0"
                v-show="img && !currentImageLoaded[img]"
                :ref="'previewImage_' + img"
                :src="`/api/image/get/menu/small/${img}`"
                :alt="'Image ' + (index + 1)"
                class="preview-image"
              />

              <!-- Image HD -->
              <img
                v-if="img && img.trim().length > 0"
                v-show="img && currentImageLoaded[img]"
                :src="`/api/image/get/menu/${img}`"
                :alt="'Image ' + (index + 1)"
                class="full-image"
                @load="onHdImageLoad(img)"
              />


              <div v-if="index != null && modalDescription.imagesCode && modalDescription.imagesCode.length > 1"
                  class="image-counter text-center"
                  style="z-index: 10;" >
                  {{ index + 1 }} <span style="font-size:9px;">/</span> {{ modalDescription.imagesCode.length }}
              </div> 
            </div>
          </div>

          
        </SplideSlide>
      </Splide>

      <div v-if="modalDescription && modalDescription.imagesCode && modalDescription.imagesCode.length > 1" class="splide__arrows-custom">
        <button class="splide__arrow splide__arrow--prev "  type="button" style="background-color: transparent;"  @click="goPrev">
          <img src="@/assets/icons/instam-arrow-left.svg" alt height="30px" width="30px" />
        </button>
        <button class="splide__arrow splide__arrow--next" style="background-color: transparent;" @click="goNext">
          <img src="@/assets/icons/instam-arrow-left.svg" class="rotate-180" alt height="30px" width="30px"  />
        </button>
      </div>


      <div class="p-2">
        <h5 class="item-title-modal text-center text-dark mb-2"
            :style="{
              fontFamily: menu.productFontFamily || 'inherit',
              color: menu.productFontColor || 'inherit',
              fontSize: menu.productFontSize || 'inherit',
              textDecoration: menu.productTextDecoration || 'inherit',
              fontStyle: menu.productFontStyle || 'inherit',
              fontWeight: menu.productFontWeight || 'inherit'
            }"
        >
        {{ modalDescription.name }}
      
        <span class="float-right" >
          <img v-if="isInWishlist(modalDescription.id)" src="@/assets/icons/heart-full-red.svg"  height="30" alt="heart"  @click="removeFromWishlist(modalDescription.id,true)"  />
          <img  v-else src="@/assets/icons/heart-red.svg"  height="30" alt="heart" @click="addToWithList(modalDescription.id,true)" />
        </span>

      </h5>
        <p v-if="modalDescription.description" class="text-gold fs-6" 
              v-html="modalDescription.description ? modalDescription.description.replace(/\n/g, '<br/>') : '-'"
          :style="{
            fontFamily: menu.productFontFamily || 'inherit',
            fontStyle: menu.productFontStyle || 'inherit',
          }"></p>
        <p class="text-dark font-size-18"
           :style="{
              fontFamily: menu.productFontFamily || 'inherit',
              fontWeight: menu.productFontWeight || 'inherit'
            }">{{ modalDescription.price }}</p>
      </div>

      </div>
      

      <div v-if="(orderIsActif || quoteIsActif)  && !modalDescription.isNotAvailableOnline " class="d-flex flex-column align-items-center pl-4 pr-4 pb-3">

             
        <div class="mt-2 w-100 d-flex justify-content-center">
          <TruncatedText
            :text="$t('menuOrder.cart.showNote')"
            :showMoreLabel="$t('menuOrder.cart.showMore')"
            :showLessLabel="$t('menuOrder.cart.showLess')"
            @onClick="showNoteField(modalDescription)"
          />
        </div>

        <b-form-textarea
          v-model="lineNote"
          placeholder="Ajouter une note..."
          rows="1"
          class="mt-2 w-100"
        />


      </div>



      <div v-if="(orderIsActif || quoteIsActif)  && !modalDescription.isNotAvailableOnline " class="d-flex align-items-center justify-content-center">

        <QuantityControl
          :item="modalDescription"
          :manualInput="this.quoteIsActif"
          :quantity="quantity"
          :addToOrderAuto="false"
          :iconSize="24"
          :fontSize="20"
          :btnSize="50"
          @updateQuantity="handleQuantityChange"
        />

      </div>

      <div v-if="(orderIsActif || quoteIsActif)  && !modalDescription.isNotAvailableOnline " class="d-flex align-items-center justify-content-center my-4 mx-3">
        <b-button @click="addToOrder()"  variant="success" class="btn-pill text-white font-weight-bold font-size-16 text-uppercase add-to-cart-btn position-relative w-100">
            {{ $t('menuOrder.cart.button.addItemToCart', { quantity: this.quantity == 1 ? '' : this.quantity }) }}
        </b-button>
      </div>




    </b-modal>

    <LocationPermissionModal v-if="coordsError"
      :show.sync="coordsError"
      @refreshLocation="refreshLocation"
    />

    <CartSummary v-if="this.orderIsActif && !this.menu.orderMenuWithQuote" @expand="expandSheet" />
    <EnableQuote v-if="this.isTable && !this.orderIsActif && this.menu.orderMenuWithQuote" :quoteIsActif="quoteIsActif" @actifQuote="actifQuote" @expand="expandSheet" />

    <CartBottomSheet  :orderIsActif="orderIsActif" :quoteIsActif="quoteIsActif" v-show="showSheet" @closeSheet="closeSheet" ref="cartComp"/>


    <FloatingButton
      v-if="orderIsActif && menu && menu.orderMenuCallWaiterIsActive && (this.tid != null && this.tid < 100000 ) && !this.quoteIsActif"
      :bottom="showCartSummary ? '85px' : '15px'"
      left="10px"
      right="auto"
      :currentLang="this.currentLang"
    >
    </FloatingButton>



    <footer class="digitable-footer text-center py-1">
      <a 
        href="https://digitablesolution.com" 
        target="_blank" 
        rel="noopener noreferrer"
        class="digitable-link d-inline-flex align-items-center justify-content-center"
      >
        <span class="mr-2">Powered by</span>
        <img src="@/assets/images/sm-logo.png" alt="DIGITABLE" class="digitable-logo" />
      </a>
    </footer>


  </div>
</template>


<style scoped>

.digitable-footer {
  background-color: rgba(0, 0, 0, 0.05);
  border-top: 1px solid #eee;
  font-size: 13px;
}

.digitable-link {
  color: #555;
  text-decoration: none;
  font-weight: 500;
}

.digitable-link:hover {
  color: #000;
  text-decoration: underline;
}

.digitable-logo {
  height: 18px;
  object-fit: contain;
}


.image-counter {
  position: absolute;
  top: 17px;
  left: 50%;
  transform: translateX(-50%);
  padding: 2px 8px;
  background-color: rgba(0, 0, 0, 0.6);
  color: #ddd;
  opacity: 0.4;
  border-radius: 12px;
  font-size: 12px;
  z-index: 10;
  width: 60px;
  text-align: center;
}


.item-wishlist-line{
  justify-content: center;
  align-items: center;    
  height: 100%;
}

.modal-description-header {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
}


.item-title-modal{
  font-size: 8vw;
  line-height: 9vh;
  color: #000;
}

.add-to-cart-icon-wishlist {
    position: absolute;
    background-color: #c8e2cda9;
    border-radius: 50%;
    top: 60%;
    right: 8.8px;
    padding: 2px;
    cursor: pointer;
}


.image-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
}

.wishlist-img {
  width: 100%;
  height: 100%;
  object-fit: cover; /* pour bien remplir sans déformer */
  border-radius: 8px; /* optionnel : coins arrondis */
}



</style>

<style scoped>

.rotate-180 {
  transform: rotate(180deg);
  transition: transform 0.5s ease-in-out;
}

.itm-table{
    display: flex;
    flex-flow: row nowrap;
    overflow-x: auto;
    overflow-y: hidden;
    scroll-snap-type: x mandatory;
    scroll-behavior: smooth;
    padding: 0;
}

.menu-screen{
    font-family: Poppins, sans-serif;
}


.item-list {
    margin: auto;
    display: -webkit-box;
    display: -moz-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-direction: normal;
    -webkit-box-orient: vertical;
    -moz-box-direction: normal;
    -moz-box-orient: vertical;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    position: relative;
    background-color: white;
    border-radius: 5px;
    border-bottom: 1px solid #ffff;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
}

.banner-title{
  justify-content: center;
}

.banner-zone{
    max-width: 80%;
    margin: auto;
    display: flex;
    justify-content: center;
    text-align: center;
    padding-top: 25px;
    padding-bottom: 25px;
    font-weight: 300;
}


.image-container {
  width: 100px;
  height: 100px;
  flex-shrink: 0;
}

.wishlist-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 0.25rem;
}

.line-clamp-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  line-height: 1.4em;
  max-height: calc(1.4em * 2);
}


.item-modal-img{
  width: 100%;
  height: auto;
}


::v-deep .modal-content .modal-body{
  padding: 0px !important;
  margin: 0px !important;
  background-color: white;
  border-radius: 5px;
}

::v-deep .modal-content{
    background-color: transparent;
    border-color: transparent;
}

.bannerTitle-zone{
  text-align: center;
  position: absolute;
  top: 104px;
}

.bannerSubTitle-zone{
  text-align: center;
  position: absolute;
  top: 140px;
}


.splide__arrows-custom {
  position: absolute;
  top: 38%;
  width: 100%;
  pointer-events: none;
}

.splide__arrow {
  pointer-events: all;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 20;
  border: none;
  background: none;
  cursor: pointer;
}
.splide__arrow--prev {
  left: 10px;
}
.splide__arrow--next {
  right: 10px;
}

.second-navbar {
  top: 34px;
  z-index: 1040;
}

.add-to-cart-btn {
  border-radius: 15px;
  padding: 1rem 0rem;
  background: linear-gradient(90deg, #28a745, #218838);
  transition: all 0.2s;
}

.add-to-cart-btn:hover {
  transform: scale(1.05);
  box-shadow: 0 6px 16px rgba(0,0,0,0.25);
}


/* .bell-effect-diagonal {
  display: inline-block;
  transform-origin: center;
  animation: swing-diagonal 1s infinite ease-in-out;
}

@keyframes swing-diagonal {
  0%   { transform: rotate(45deg); }
  10%  { transform: rotate(60deg); }
  20%  { transform: rotate(35deg); }
  30%  { transform: rotate(55deg); }
  40%  { transform: rotate(40deg); }
  50%  { transform: rotate(50deg); }
  60%  { transform: rotate(42deg); }
  70%  { transform: rotate(48deg); }
  80%  { transform: rotate(44deg); }
  90%  { transform: rotate(46deg); }
  100% { transform: rotate(45deg); }
} */

.preview-image,
.full-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: opacity 0.4s ease;
}

.scroll-down-btn {
  position: absolute;
  bottom: 55px;
  right: 0px;
  transform: translateX(-50%);
  background: rgba(255, 255, 255, 0.2);
  border: 2px solid rgba(255, 255, 255, 0.6);
  border-radius: 50%;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  animation: bounce 1.5s infinite;
  backdrop-filter: blur(4px);
}

.scroll-down-btn:hover {
  background: rgba(255, 255, 255, 0.35);
}

@keyframes bounce {
  0%, 100% { transform: translateX(-50%) translateY(0); }
  50%       { transform: translateX(-50%) translateY(6px); }
}

.banner-offset-with-groups {
  padding-top: 75px;
}
.banner-offset-no-groups {
  padding-top: 30px;
}

</style>


<style>
@import url('https://fonts.googleapis.com/css2?family=Amiri:ital,wght@0,400;0,700;1,400;1,700&family=Borel&family=Dancing+Script:wght@400..700&family=Fustat:wght@200..800&family=Katibeh&family=Lateef:wght@200;300;400;500;600;700;800&family=Mada:wght@200..900&family=Marhey:wght@300..700&family=Markazi+Text:wght@400..700&family=Noto+Kufi+Arabic:wght@100..900&family=Noto+Sans+Arabic:wght@100..900&family=Pacifico&family=Scheherazade+New:wght@400;500;600;700&family=Sour+Gummy:ital,wght@0,100..900;1,100..900&family=Tajawal:wght@200;300;400;500;700;800;900&family=Zain:ital,wght@0,200;0,300;0,400;0,700;0,800;0,900;1,300;1,400&display=swap');
</style>